import GuestlistEntryTypeDropdown from "components/dropdowns/reactselect/GuestlistEntryTypeDropdown";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { useValidateIsNotNull } from "formvalidation/hooks";
import React from "react";

export interface EntryTypeInputValue {
  entryType: server.dto.GuestlistEntryType;
  customLabel: string;
}

interface Props {
  value: EntryTypeInputValue
  validatorKey: string
  focusOnMount?: boolean
  onChange: (value: EntryTypeInputValue, submit: boolean) => void
  submit?: () => void
  cancel?: () => void
}

export const EntryTypeInput = (props: Props) => {
  const validation = useValidateIsNotNull({
    key: props.validatorKey,
    title: RESX.GeneralLabels.CustomValue,
    value: props.value.entryType,
  });

  return <div className="flex-column gap-mini">
    <GuestlistEntryTypeDropdown
      value={props.value.entryType}
      onChange={(p: server.dto.GuestlistEntryType) => {
        // If the value is other, we need to provide a value
        props.onChange({ entryType: p, customLabel: "" }, p.value !== "customName");
      }}
      onEsc={() => props.cancel()}
      config={{
        hasError: validation.error.hasError,
        focusOnMount: props.focusOnMount && props.value.entryType.value !== "customName",
        openMenuOnFocus: props.focusOnMount && props.value.entryType.value !== "customName",
      }}
    />
    {(props.value.entryType && props.value.entryType.value === "customName") && <RequiredTextInput
      validatorKey={`${props.validatorKey}-other-label`}
      focusOnMount
      maxLength={serverReference.constants.guestlist.maxPlaceCustomNameLength}
      value={props.value.customLabel}
      onChange={(customLabel) => { props.onChange({ ...props.value, customLabel }, false); }}
      onEnter={() => props.submit?.()}
      onEsc={() => props.cancel?.()}
    />}
  </div>
}